module.exports = __webpack_public_path__ + "img/level-icons-sp.30bebb75.png";